<template>
  <div class="container-col">
    <h1 class="row-fit">
      {{lemma}}
      <span class="subtitle"> {{arabicPos(pos)}} </span>
    </h1>
    <div v-if="patternGroups === null" class="row-fill">
      <div class="loader"/>
    </div>
    <div v-else class="row-fill container-col-wrapped">
      <pattern-group v-for="g in orderedPatterns" :key="g.pattern + g.core_indexes"
        :lempos="lempos" :pattern="g.pattern" :core-indexes="g.core_indexes"
        class="wrappable-row-fit pattern-group" :class='g.css_label'/>
    </div>
  </div>
</template>

<script>
import PatternGroup from './PatternGroup'
import { SORTED_QUALIFIED_PATTERNS } from '../lib/patters'

export default {
  name: 'DictEntryView',
  props: {
    lempos: String,
    collLempos: String,
    collPattern: String
  },
  components: {
    PatternGroup
  },
  created: function () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  computed: {
    lemma: function () { return this.lempos.split('+')[0] },
    pos: function () { return this.lempos.split('+')[1] },
    patternGroups: function () { return this.$store.state.groups[this.lempos] },
    _sortedPatterns: function () { return SORTED_QUALIFIED_PATTERNS[this.pos] },
    orderedPatterns: function () {
      return this._sortedPatterns.filter(g => this.$store.getters.getGroupsForQualifiedPattern(this.lempos, g.pattern, g.core_indexes))
    }
  },
  methods: {
    fetchData () {
      this.$store.dispatch('loadGroups', { lempos: this.lempos })
    }
  }
}
</script>

<style scoped>
  /* Styling of pattern groups */
  .pattern-group {
    border-right: 2px solid var(--fg-color);
    background-color: #F5F5F5;
    margin: 20px;
    padding-right: 10px;
    padding-bottom: 10px
  }
  div >>> .links {
    clear: both;
    font-size: 80%;
    padding: 5px;
    /* Glue the links to be bottom of the pattern group box */
    padding-bottom: 0;
    margin-bottom: -5px
  }
  div >>> .links a {
    color: grey
  }
  div >>> .pattern-title {
    /* margin-right: -10px; */
    padding: 10px 5px 0 5px;
    /* color: var(--group-color) */
  }
  div >>> .collocation {
    background-color: var(--bg-color)
  }
  div >>> .list-title {
    clear: both;
    width: 100%;
    padding: 10px 5px 0px 5px;
    font-size: 80%;
    /* border-top: 1px solid lightgrey; */
    color: gray;
  }
</style>
